import React, { useEffect } from "react";
import PageHeader from "../../components/PageHeader";
import WasteTypeCategoryListComponent from "../../components/WasteTypeCategory/WasteTypeCategoryList";
import { useParams } from "react-router-dom";


export default function WasteTypeCategoryList() {
    useEffect(() => {
        window.scrollTo(0, 0);
    })

    return (
        <div
            style={{ flex: 1 }}
            onClick={() => {
                document.body.classList.remove("offcanvas-active");
            }}
        >
            <div>
                <div className="container-fluid">
                    <PageHeader
                        HeaderText="Waste Types"
                        Breadcrumb={[
                            { name: "Waste Types", navigate: "" },
                        ]}
                    />
                    <div className="row clearfix">
                        <WasteTypeCategoryListComponent />
                    </div>
                </div>
            </div>
        </div>
    );
}
